import DetailsForm from "components/LM/Voice/DetailsForm";
import DateFormat from "components/LM/common/DateFormat";
import BrandQueries from 'components/LM/Voice/BrandQueries';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import Card from "react-bootstrap/Card";
import { MapPin } from 'react-feather';
import { Loader, Badge, Button, Tooltip } from "@launchmetrics/lm-ui";
import 'components/LM/Voice/Details.scss';

function Details(props, ref) {
	const { voice, editMode, onSave, onCancel} = props;

	const [changes, setChanges] = useState(false);
	const [loading, setLoading] = useState(false);

	const detailFormRef = useRef();
	useImperativeHandle(
		ref, () => ({
			discardChanges() {
				detailFormRef.current.onDiscard();
			},
			saveChanges(onUpdateVoice) {
				setLoading(true);
				return detailFormRef.current.onSubmit(onUpdateVoice).then(() => {
					setLoading(false);
				});
			}
		})
	);

	const showLoader = () => {
		if (loading) {
			return <Loader styleProps={{ marginLeft: '10px'}} size={20} />;
		}
	}

	const onChange = (hasChanges) => {
		setChanges(hasChanges);
	}

	const lastDataUpdateAt = (date) => {
		return <>
			<Tooltip
				placement="top"
				content={<><DateFormat>{date}</DateFormat></>}
				styleProps={{
					color: '#fff'
				}}
			>
				<div className="last-data">
					<DateFormat>{date}</DateFormat>
				</div>
			</Tooltip>
		</>
	};

	const detailsLink = (name, link) => {
		return <>
			<Tooltip
				placement="top"
				content={name}
			>
				<a href={link} className="details-link" target="_blank" rel="noreferrer">{name}</a>
			</Tooltip>
		</>
	};

	const details = editMode ? <Card.Body><DetailsForm ref={detailFormRef} onChange={onChange} onLoading={setLoading} voice={voice} /></Card.Body> : <DetailsInfo voice={voice} />
	return (
		<Card className="details">
			{details}
			<hr className="my-0" />
			<BrandQueries voiceId={voice.id} />
			<Card.Body>
				<Card.Title className="details-title">Details</Card.Title>
				<Card.Text as="div">
					<ul className="list-unstyled">
						<li>
							<span className="label">ID:</span>
							<span className="value">{voice.id}</span>
						</li>
						<li>
							<span className="label">Inserted at:</span>
							<span className="value">
								{lastDataUpdateAt(voice.inserted_at)}
							</span>
						</li>
						<li>
							<span className="label">Updated at:</span>
							<span className="value">
								{lastDataUpdateAt(lastDateUpdateAt(voice))}
							</span>
						</li>
					</ul>
				</Card.Text>
				{voice.celebrity && (
					<>
						<Card.Title className="details-title">Celebrity Details</Card.Title>
						<Card.Text as="div">
							<Row className="gy-2">
								<Col xs={12} sm={4} >ID:</Col>
								<Col xs={12} sm={8} className="text-right">{voice.celebrity?.id}</Col>

								<Col xs={12} sm={4} >Name:</Col>
								<Col xs={12} sm={8} className="text-right">{detailsLink(voice.celebrity.name, voice.celebrity.bio_link)}</Col>

								<Col xs={12} sm={4} >Description:</Col>
								<Col xs={12} sm={8} className="text-right">{voice.celebrity.description}</Col>
							</Row>
						</Card.Text>
					</>
				)}


			</Card.Body>
			{editMode && (
				<Card.Body>
					<div className="d-flex justify-content-end">
					<Button key={`btnSave`} size="small" className="manage btn-sm ml-2" disabled={loading || (voice.status !== 'candidate' && (!editMode || !changes))} onClick={onSave}>
						{voice.status === 'candidate' ? 'Validate' : 'Save changes'}
						{showLoader()}
					</Button>
					<Button key={`btnCancel`} size="small" className="manage btn-sm ml-2" disabled={!changes} onClick={onCancel}>Cancel</Button>
					</div>
				</Card.Body>
			)}
		</Card >
	)
}

function DetailsInfo(props) {
	const { voice } = props

	let country;
	if ('country' in voice) {
		country = (
			<Card.Text as="div" className="mb-1">
				<MapPin size={14} /> {voice.country.name}
			</Card.Text>
		);
	}

	voice.labels.sort((first, second) => first.name.localeCompare(second.name));
	const labels = voice.labels.map(label => (<Label key={`label${label.id}`} {...label} />));

	return <>
		<Card.Body className="text-center">
			<Card.Title className="name mb-0" as="h3">
				{voice.name}
			</Card.Title>
			<Card.Text as="div" className="text-capitalize text-muted mb-2">
				{voice.type}
			</Card.Text>
			{country}
		</Card.Body>
		<hr className="my-0" />

		<Card.Body>
			<Card.Title>Labels</Card.Title>
			<Card.Text className="labels">
				{labels}
			</Card.Text>
		</Card.Body>
	</>
}

function Label({ name }) {
	return (
		<Badge className="label mr-1" variant="primary">{name}</Badge>
	)
}

function lastDateUpdateAt(voice) {
	const arrayDates = [];
	arrayDates.push(new Date(voice.updated_at));

	voice.labels.forEach(item => {
		if (item.hasOwnProperty('added_at')) {
			arrayDates.push(new Date(item.added_at))
		}
	});

	arrayDates.push(getRelationDates(voice.medias));
	arrayDates.push(getRelationDates(voice.socialmedia));

	return new Date(Math.max.apply(null, arrayDates.flat())).toISOString();
}

function getRelationDates(entities) {

	return Object.values(entities)
		.filter(Array.isArray)
		.flat()
		.filter(item => item.hasOwnProperty('added_at'))
		.map(item => new Date(item['added_at']));
}

export default forwardRef(Details);
